export const MEMBER_BADGES_LIST = 'members-badges';
export const MEMBER_BADGES_ITEM = 'badge root';
